import { Button } from '@mui/material';
import { SnackbarKey, useSnackbar, closeSnackbar } from 'notistack';
import React from 'react';

let useSnackbarRef: any;
export const SnackbarUtilsConfigurator = () => {
  useSnackbarRef = useSnackbar();
  return null;
};

export const enqueueSnackbarGlobal = (
  msg: string,
  variant: 'error' | 'success' = 'error'
): SnackbarKey => {
  return useSnackbarRef.enqueueSnackbar(msg, { variant });
};

// Show error toast globally
export const showErrorToast = (message: string) => {
  if (!message || !useSnackbarRef) return;

  useSnackbarRef.enqueueSnackbar(message, {
    variant: 'error',
    autoHideDuration: 5000,
    anchorOrigin: { vertical: 'top', horizontal: 'right' },
    action: (snackbarId: SnackbarKey) =>
      React.createElement(
        Button,
        {
          onClick: () => closeSnackbar(snackbarId),
          sx: {
            color: '#fff',
            minWidth: 'auto',
          },
        },
        '✕'
      ),
  });
};

//  Show success toast globally
export const showSuccessToast = (message: string) => {
  if (!message || !useSnackbarRef) return;

  useSnackbarRef.enqueueSnackbar(message, {
    variant: 'success',
    autoHideDuration: 4000,
    anchorOrigin: { vertical: 'top', horizontal: 'right' },
    action: (snackbarId: SnackbarKey) =>
      React.createElement(
        Button,
        {
          onClick: () => closeSnackbar(snackbarId),
          sx: {
            color: '#fff',
            minWidth: 'auto',
          },
        },
        '✕'
      ),
  });
};
